import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import { switchAssessmentSendReminderEmail } from 'requests/EmailRequests';
import PreviewRemindEmailButton from 'components/assessments_pages/asessment_settings_components/InstructionToCandidatesSection/components/RemindEmailFooter/PreviewRemindEmailButton';
import DeadlineForm from 'components/assessments_pages/asessment_settings_components/DeadlineForm';
import { withStyles } from '@mui/styles';
import { addDays, set } from 'date-fns';
import styles from './styles';

const DEFAULT_DAYS_COUNT = 2;

const CandidateReminder = (props) => {
    const { setSaving, settings, audition, setAudition, changeAssessmentSettings } = props;
    const { daysToExpiration, expirationDate } = settings;
    const { slug, sendReminderEmail } = audition;

    const [isSettingsActive, setIsSettingActive] = useState(sendReminderEmail);

    const handleChangeRemind = async (e) => {
        const { checked } = e.target;
        setSaving(true);
        setIsSettingActive(checked);
        await switchAssessmentSendReminderEmail(slug);
        setSaving(false);
        setAudition({ ...audition, sendReminderEmail: checked });
    };

    const onDaysChange = (newValue) => {
        changeAssessmentSettings({
            reminderDays: newValue,
            reminderDateAt: null,
            reminderDaysEnabled: true
        })
            .then(() => {
                setAudition({
                    ...audition,
                    reminderDays: newValue,
                    reminderDateAt: null
                });
            });
    };

    const onChangeDeadlineDate = (newDate) => {
        if (newDate) {
            changeAssessmentSettings({
                reminderDateAt: newDate,
                reminderDays: -1,
                reminderDaysEnabled: false
            }).then(() => {
                setAudition({
                    ...audition,
                    reminderDateAt: newDate,
                    reminderDays: -1
                });
            });
        }
    };

    const onChangeDeadlineType = (type, date = null) => {
        const isDays = type === 'days';

        if (isDays) {
            changeAssessmentSettings({
                reminderDaysEnabled: true,
                reminderDays: DEFAULT_DAYS_COUNT,
                reminderDateAt: null
            }).then(() => {
                setAudition({
                    ...audition,
                    reminderDaysEnabled: true,
                    reminderDays: DEFAULT_DAYS_COUNT,
                    reminderDateAt: null
                });
            });
        } else if (date) {
            changeAssessmentSettings({
                reminderDaysEnabled: false,
                reminderDateAt: date
            }).then(() => {
                setAudition({
                    ...audition,
                    reminderDaysEnabled: false,
                    reminderDateAt: date
                });
            });
        } else {
            setAudition({
                ...audition,
                reminderDaysEnabled: false
            });
        }
    };

    const getRemindType = () => {
        if (settings.reminderDaysEnabled || !settings.reminderDateAt) {
            return 'days';
        }
        return 'date';
    };

    const minDate = set(addDays(new Date(), 1), {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    });

    return (
        <>
            <div className="u-dsp--distribute u-fw--wrap u-wdt--100p">
                <div>
                    <Typography variant="h5" className="u-mrg--bx1">Candidate Reminder</Typography>
                    <div>Send email reminder if no activity by candidate</div>
                    <PreviewRemindEmailButton audition={audition} settings={settings} />
                </div>
                <Switch
                    disabled={daysToExpiration === -1 && !expirationDate}
                    checked={isSettingsActive && (daysToExpiration > -1 || expirationDate)}
                    onChange={handleChangeRemind}
                    value="reminder"
                />
            </div>
            <div>
                <Typography variant="h5" className="u-mrg--tx4">Set Date for Reminder Email</Typography>
                <DeadlineForm
                    {...props}
                    initDays={settings.reminderDays > -1 ? settings.reminderDays : DEFAULT_DAYS_COUNT}
                    initType={getRemindType()}
                    initDate={settings.reminderDateAt}
                    min={1}
                    max={180}
                    defaultDeadline={DEFAULT_DAYS_COUNT}
                    onDaysChange={(onDaysChange)}
                    onChangeDeadlineType={onChangeDeadlineType}
                    onChangeDeadlineDate={onChangeDeadlineDate}
                    dateLabel="Set reminder date and time"
                    disabled={!isSettingsActive}
                    errorText="Value must be between 1 and 180 days."
                    minDate={minDate}
                    daysSuffix="Days before deadline"
                />
            </div>
        </>
    );
};

export default withStyles(styles)(CandidateReminder);
